<template>
  <div>
    <h4>OS</h4>
    <b-row>
      <b-col md="6">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Resumo das Ordens de Serviço:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_os"
                    label-for="data_inicial_os"
                    label="Data Inicial de entrada"
                  >
                    <b-form-input type="date" v-model="data_inicial_os">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_os"
                    label-for="data_final_os"
                    label="Data Final de entrada"
                  >
                    <b-form-input type="date" v-model="data_final_os">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Cliente" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setCliente"
                      :options="clientes"
                      @search="onSearchCliente"
                      v-model="cliente_os"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Técnico" label-for="nome">
                    <VueSelect
                      ref="buscarTecnico"
                      :filterable="false"
                      @input="setTecnico"
                      :options="tecnicos"
                      @search="onSearchTecnico"
                      v-model="tecnico_os"
                    >
                      <template slot="no-options">
                        Informe o nome do técnico
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Objeto" label-for="nome">
                    <VueSelect
                      ref="buscarObjeto"
                      :filterable="false"
                      @input="setObjeto"
                      :options="objetos"
                      @search="onSearchObjeto"
                      v-model="objeto_os"
                    >
                      <template slot="no-options">
                        Informe a descrição do objeto
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.descricao }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Selecione o status" label-for="status">
                    <VueSelect
                      ref="buscarStatus"
                      :filterable="false"
                      :options="osStatus"
                      v-model="statusSelectedOS"
                    >
                      <template slot="no-options"> Informe o status </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="% Comissão do técnico no serviço"
                    label-for="comissao_tecnico"
                  >
                    <money
                      class="form-control"
                      v-bind="configMask"
                      id="comissao_tecnico"
                      name="comissao_tecnico"
                      v-model="comissao_tecnico_servico"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Solicitante" label-for="solicitante">
                    <b-form-input
                      class="form-control"
                      id="solicitante"
                      name="solicitante"
                      v-model="solicitante"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="custo_produtos"
                    label-for="custo_produtos"
                    label="Gerar custo dos produtos"
                  >
                    <span class="switch switch-icon">
                      <label>
                        <input
                          type="checkbox"
                          :value="false"
                          @change="setCustoItens"
                          :checked="custo_produtos == true"
                        />
                        <span></span>
                      </label>
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_os"
                      id="ordenacao_os"
                      v-model="ordenacao_os"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenacao_os_det"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <button
                @click="gerarResumoOS()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="6">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Resumo das Ordens de Serviço com horários:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_os_horario"
                    label-for="data_inicial_os_horario"
                    label="Data Inicial de entrada"
                  >
                    <b-form-input type="date" v-model="data_inicial_os_horario">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_os_horario"
                    label-for="data_final_os_horario"
                    label="Data Final de entrada"
                  >
                    <b-form-input type="date" v-model="data_final_os_horario">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Cliente" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setClienteHorario"
                      :options="clientes"
                      @search="onSearchCliente"
                      v-model="cliente_os_horario"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Técnico" label-for="nome">
                    <VueSelect
                      ref="buscarTecnico"
                      :filterable="false"
                      @input="setTecnicoHorario"
                      :options="tecnicos"
                      @search="onSearchTecnico"
                      v-model="tecnico_os_horario"
                    >
                      <template slot="no-options">
                        Informe o nome do técnico
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Objeto" label-for="nome">
                    <VueSelect
                      ref="buscarObjeto"
                      :filterable="false"
                      @input="setObjetoHorario"
                      :options="objetos"
                      @search="onSearchObjeto"
                      v-model="objeto_os_horario"
                    >
                      <template slot="no-options">
                        Informe a descrição do objeto
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.descricao }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Selecione o status" label-for="status">
                    <VueSelect
                      ref="buscarStatus"
                      :filterable="false"
                      :options="osStatus"
                      v-model="statusSelectedHorario"
                    >
                      <template slot="no-options"> Informe o status </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="% Comissão do técnico no serviço"
                    label-for="comissao_tecnico"
                  >
                    <money
                      class="form-control"
                      v-bind="configMask"
                      id="comissao_tecnico"
                      name="comissao_tecnico"
                      v-model="comissao_tecnico_servico_horario"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Solicitante" label-for="solicitante">
                    <b-form-input
                      class="form-control"
                      id="solicitante"
                      name="solicitante"
                      v-model="solicitante_horario"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_horario"
                      id="ordenacao_horario"
                      v-model="ordenacao_horario"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenacao_os_horario"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <button
                @click="gerarResumoOSByHorarios()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
      <b-col md="6">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Resumo das Ordens de Serviço Simplificada:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_simplificada"
                    label-for="data_inicial_simplificada"
                    label="Data Inicial de manutenção"
                  >
                    <b-form-input
                      type="date"
                      v-model="data_inicial_simplificada"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_simplificada"
                    label-for="data_final_simplificada"
                    label="Data Final de manutenção"
                  >
                    <b-form-input type="date" v-model="data_final_simplificada">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Cliente" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setClienteSimplificada"
                      :options="clientes"
                      @search="onSearchCliente"
                      v-model="cliente_simplificada"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Técnico" label-for="nome">
                    <VueSelect
                      ref="buscarTecnico"
                      :filterable="false"
                      @input="setTecnicoSimplificada"
                      :options="tecnicos"
                      @search="onSearchTecnico"
                      v-model="tecnico_simplificada"
                    >
                      <template slot="no-options">
                        Informe o nome do técnico
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Objeto" label-for="nome">
                    <VueSelect
                      ref="buscarObjeto"
                      :filterable="false"
                      @input="setObjetoSimplificada"
                      :options="objetos"
                      @search="onSearchObjeto"
                      v-model="objeto_simplificada"
                    >
                      <template slot="no-options">
                        Informe a descrição do objeto
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.descricao }}
                          </div>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Selecione o status" label-for="status">
                    <VueSelect
                      ref="buscarStatus"
                      :filterable="false"
                      :options="osStatus"
                      v-model="statusSelectedSimplificada"
                    >
                      <template slot="no-options"> Informe o status </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.descricao }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_simplificada"
                      id="ordenacao_simplificada"
                      v-model="ordenacao_simplificada"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenacao_os_simplificada"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <button
                @click="gerarSimplificada()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <hr />
    <h4>NFS-e</h4>
    <b-row>
      <b-col md="6">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Resumo das NFS-e:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_nfse"
                    label-for="data_inicial_nfse"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_nfse">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_nfse"
                    label-for="data_final_nfse"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_nfse">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group label="Cliente" label-for="nome">
                    <VueSelect
                      ref="buscarCliente"
                      :filterable="false"
                      @input="setClienteNFSe"
                      :options="clientes"
                      @search="onSearchCliente"
                      v-model="cliente_nfse"
                    >
                      <template slot="no-options">
                        Informe o nome do cliente
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex justify-content-between">
                          <div>
                            {{ option.nome }}
                          </div>
                          <span class="text-muted">{{
                            formatCpfCnpj(option.cnpj_cpf)
                          }}</span>
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.label }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_nfse"
                      id="ordenacao_nfse"
                      v-model="ordenacao_nfse"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenacao_nfses"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <button
                @click="gerarResumoNFSe()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <hr />
    <h4>Contrato</h4>
    <b-row>
      <b-col md="6">
        <div class="card card-custom gutter-b">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="card-body">
              <h4>Contratos:</h4>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="data_inicial_contrato"
                    label-for="data_inicial_contrato"
                    label="Data Inicial"
                  >
                    <b-form-input type="date" v-model="data_inicial_contrato">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="data_final_contrato"
                    label-for="data_final_contrato"
                    label="Data Final"
                  >
                    <b-form-input type="date" v-model="data_final_contrato">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label="Escolha a ordenação"
                    label-for="ordenacao"
                  >
                    <select
                      name="ordenacao_contrato"
                      id="ordenacao_contrato"
                      v-model="ordenacao_contrato"
                      class="form-control"
                    >
                      <option
                        v-for="(o, index) in ordenacao_contratos"
                        :value="o.campo"
                        :key="'campo' + index"
                      >
                        {{ o.descricao }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>
              <button
                @click="gerarResumoContratos()"
                class="btn btn-primary font-weight-bold"
              >
                Gerar
              </button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import swal from "sweetalert";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "relatorios-vendas",
  mixins: [SistemaMixin, PessoaMixin],
  components: {
    VueSelect,
    Money,
  },
  directives: {
    mask,
  },
  data() {
    return {
      reportTarge: null,
      data_inicial_os: null,
      data_final_os: null,
      data_inicial_os_horario: null,
      data_final_os_horario: null,
      clienteSelectedOS: null,
      tecnicoSelectedOS: null,
      objetoSelectedOS: null,
      cliente_os: null,
      tecnico_os: null,
      objeto_os: null,
      cliente_os_horario: null,
      tecnico_os_horario: null,
      objeto_os_horario: null,
      clientes: [],
      osStatus: [],
      objetos: [],
      statusSelectedOS: null,
      statusSelectedHorario: null,
      tecnicos: [],
      configMask: settingMoney,
      comissao_tecnico_servico: 0,
      comissao_tecnico_servico_horario: 0,
      cliente_nfse: null,
      clienteSelectedNFSe: null,
      solicitante: null,
      solicitante_horario: null,
      custo_produtos: false,
      data_inicial_simplificada: null,
      data_final_simplificada: null,
      cliente_simplificada: null,
      tecnico_siplificada: null,
      objeto_simplificada: null,
      clienteSelectedSimplificada: null,
      tecnicoSelectedSimplificada: null,
      objetoSelectedSimplificada: null,
      ordenacao_os: "data_entrada",
      ordenacao_horario: "data_entrada",
      ordenacao_simplificada: "data_manutencao",
      ordenacao_nfse: "numero",
      ordenacao_os_det: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "data_entrada",
          descricao: "Data da Entrada",
        },
      ],
      ordenacao_os_horario: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "data_entrada",
          descricao: "Data da Entrada",
        },
      ],
      ordenacao_os_simplificada: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "data_manutencao",
          descricao: "Data da Manutenção",
        },
      ],
      ordenacao_nfses: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "numero",
          descricao: "Número",
        },
      ],
      ordenacao_contratos: [
        {
          campo: "cliente",
          descricao: "Cliente",
        },
        {
          campo: "data_venda",
          descricao: "Data da Venda",
        },
      ],
      data_inicial_contrato: null,
      data_final_contrato: null,
      ordenacao_contrato: "data_venda",
    };
  },
  watch: {
    reportTarge(newValue, oldValue) {
      if (newValue !== oldValue) {
        window.Echo.leaveChannel(
          "reportGenerate" + this.currentUser.usuario_empresa.id_empresa
        );
      }
    },
  },
  methods: {
    async getDataInit() {
      const { data } = await this.$http.post("/ordemservico/status");
      this.osStatus = data;
    },
    onSearchObjeto(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchObjeto(loading, search, this);
      }
    },
    searchObjeto: _.debounce(async (loading, search, vm) => {
      vm.objetos = await vm.getObjeto(search);
      loading(false);
    }, 500),
    onSearchTecnico(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchTecnico(loading, search, this);
      }
    },
    searchTecnico: _.debounce(async (loading, search, vm) => {
      vm.tecnicos = await vm.getTecnicos(search);
      loading(false);
    }, 500),
    onSearchCliente(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getClientes(search);
      loading(false);
    }, 500),
    setClienteHorario(cliente) {
      if (!cliente) return;
      this.cliente_os_horario = cliente.nome;
      this.clienteSelectedOS = cliente;
    },
    setCliente(cliente) {
      if (!cliente) return;
      this.cliente_os = cliente.nome;
      this.clienteSelectedOS = cliente;
    },
    setClienteSimplificada(cliente) {
      if (!cliente) return;
      this.cliente_simplificada = cliente.nome;
      this.clienteSelectedSimplificada = cliente;
    },
    setClienteNFSe(cliente) {
      if (!cliente) return;
      this.cliente_nfse = cliente.nome;
      this.clienteSelectedNFSe = cliente;
    },
    setTecnico(tecnico) {
      if (!tecnico) return;
      this.tecnico_os = tecnico.nome;
      this.tecnicoSelectedOS = tecnico;
    },
    setTecnicoSimplificada(tecnico) {
      if (!tecnico) return;
      this.tecnico_simplificada = tecnico.nome;
      this.tecnicoSelectedSimplificada = tecnico;
    },
    setTecnicoHorario(tecnico) {
      if (!tecnico) return;
      this.tecnico_os_horario = tecnico.nome;
      this.tecnicoSelectedOS = tecnico;
    },
    setObjeto(objeto) {
      if (!objeto) return;
      this.objeto_os = objeto.descricao;
      this.objetoSelectedOS = objeto;
    },
    setObjetoSimplificada(objeto) {
      if (!objeto) return;
      this.objeto_simplificada = objeto.descricao;
      this.objetoSelectedSimplificada = objeto;
    },
    setObjetoHorario(objeto) {
      if (!objeto) return;
      this.objeto_os_horario = objeto.descricao;
      this.objetoSelectedOS = objeto;
    },
    gerarResumoOSByHorarios() {
      if (!this.data_inicial_os_horario || !this.data_final_os_horario) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Sair",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/os-horarios", {
            data_inicial: this.data_inicial_os_horario,
            data_final: this.data_final_os_horario,
            id_pessoa: this.clienteSelectedOS?.id_pessoa ?? null,
            id_tecnico: this.tecnicoSelectedOS?.id_tecnico ?? null,
            status: this.statusSelectedHorario?.id ?? null,
            id_objeto: this.objetoSelectedOS?.id_objeto ?? null,
            comissao_tecnico_servico:
              this.comissao_tecnico_servico_horario ?? 0,
            solicitante: this.solicitante_horario ?? null,
            ordenacao_os: this.ordenacao_horario ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarSimplificada() {
      if (!this.data_final_simplificada || !this.data_final_simplificada) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Sair",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/os-simplificada", {
            data_inicial: this.data_inicial_simplificada,
            data_final: this.data_final_simplificada,
            id_pessoa: this.clienteSelectedSimplificada ?? null,
            id_tecnico: this.tecnicoSelectedSimplificada ?? null,
            status: this.statusSelectedSimplificada ?? null,
            id_objeto: this.objetoSelectedSimplificada ?? null,
            ordenacao_os: this.ordenacao_simplificada ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarResumoOS() {
      if (!this.data_inicial_os || !this.data_final_os) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Sair",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/os", {
            data_inicial: this.data_inicial_os,
            data_final: this.data_final_os,
            id_pessoa: this.clienteSelectedOS?.id_pessoa ?? null,
            id_tecnico: this.tecnicoSelectedOS?.id_tecnico ?? null,
            status: this.statusSelectedOS?.id ?? null,
            id_objeto: this.objetoSelectedOS?.id_objeto ?? null,
            comissao_tecnico_servico: this.comissao_tecnico_servico ?? 0,
            solicitante: this.solicitante ?? null,
            custo_produtos: this.custo_produtos ?? false,
            ordenacao_os: this.ordenacao_os ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    setCustoItens() {
      this.custo_produtos = this.custo_produtos == true ? false : true;
    },
    gerarResumoNFSe() {
      if (!this.data_inicial_nfse || !this.data_inicial_nfse) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Sair",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/nfse", {
            data_inicial: this.data_inicial_nfse,
            data_final: this.data_final_nfse,
            id_pessoa: this.clienteSelectedNFSe?.id_pessoa ?? null,
            ordenacao_nfse: this.ordenacao_nfse ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    gerarResumoContratos() {
      if (!this.data_inicial_contrato || !this.data_final_contrato) {
        this.$toast.warning("Informe as datas para gerar o relatório!");
        return;
      }
      swal({
        title: "Deseja realizar a visualização do relatório?",
        text: "Aguarde, pois será notificado no menu quando o relátorio será gerado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Sair",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/relatorios/contrato", {
            data_inicial: this.data_inicial_contrato,
            data_final: this.data_final_contrato,
            ordenacao_contrato: this.ordenacao_os ?? null,
          })
          .then(() => {
            swal.stopLoading();
            swal.close();
            this.$toast.success("Solicitação realizada com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() {
    await this.getDataInit();
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
